export default {
    state: {
        data: [],
        loadingData: false,
        dataDetails: [],
        loadingDataDetails: false,
        byReturns: [0, 0, 0],
        loadingByReturns: false,
        byWeeks: [],
        loadingByWeeks: false,
        byVersions: [],
        loadingByVersions: false,
        snackBar: {
            visible: false,
            message: ''
        },

    },
    mutations: {
        setComandosValidacaoLogData(state, payload) {
            state.data = []
            state.dataDetails = []

            payload.forEach(element => {
                if (element) {
                    state.data.push({
                        ...element,
                        detail: [],
                        expanded: false
                    })
                }
            });
        },
        setComandosValidacaoLogDataExpanded(state, payload) {
            state.data.forEach(element => {
                if (element == payload)
                    element.expanded = !element.expanded
            })
        },
        setComandosValidacaoLogLoadingData(state, payload) {
            state.loadingData = payload
        },
        setComandosValidacaoLogDataDetails(state, payload) {
            state.dataDetails.push(payload)
        },
        setComandosValidacaoLogLoadingDataDetails(state, payload) {
            state.loadingDataDetails = payload
        },
        setComandosValidacaoLogByReturns(state, payload) {
            state.byReturns = payload
        },
        setComandosValidacaoLogLoadingByReturns(state, payload) {
            state.loadingByReturns = payload
        },
        setComandosValidacaoLogByWeeks(state, payload) {
            state.byWeeks = payload

            if (state.byWeeks != null) {
                state.byWeeks.series = []
                state.byWeeks.categories = []
                var serieWithErrors = {
                    name: 'Com erros',
                    data: []
                }
                var serieNonReturns = {
                    name: 'Sem retornos',
                    data: []
                }
                var serieWithReturns = {
                    name: 'Com retornos',
                    data: []
                }

                state.byWeeks.forEach(byWeek => {
                    serieWithErrors.data.push(Number(byWeek.withError))
                    serieNonReturns.data.push(Number(byWeek.nonReturn))
                    serieWithReturns.data.push(Number(byWeek.withReturn))
                    const category = `Semana ${byWeek.week}`

                    state.byWeeks.categories.push(category)
                })
                state.byWeeks.series.push(serieWithErrors)
                state.byWeeks.series.push(serieNonReturns)
                state.byWeeks.series.push(serieWithReturns)
            }
        },
        setComandosValidacaoLogLoadingByWeeks(state, payload) {
            state.loadingByWeeks = payload
        },
        setComandosValidacaoLogByVersions(state, payload) {
            state.byVersions = payload

            if (state.byVersions != null) {
                state.byVersions.series = []
                state.byVersions.categories = []
                var serieWithErrors = {
                    name: 'Com erros',
                    data: []
                }
                var serieNonReturns = {
                    name: 'Sem retornos',
                    data: []
                }
                var serieWithReturns = {
                    name: 'Com retornos',
                    data: []
                }

                state.byVersions.forEach(byVersion => {
                    serieWithErrors.data.push(parseInt(byVersion.withError))
                    serieNonReturns.data.push(parseInt(byVersion.nonReturn))
                    serieWithReturns.data.push(parseInt(byVersion.withReturn))
                    const category = byVersion.COMVALLOGVERSAOSISTEMA

                    state.byVersions.categories.push(category)
                })
                state.byVersions.series.push(serieWithErrors)
                state.byVersions.series.push(serieNonReturns)
                state.byVersions.series.push(serieWithReturns)
            }
        },
        setComandosValidacaoLogLoadingByVersions(state, payload) {
            state.loadingByVersions = payload
        },
        setComandosValidacaoLogSnackBar(state, payload) {
            state.snackBar.visible = payload.visible
            state.snackBar.message = payload.message
        },
    },
    actions: {
        setComandosValidacaoLogData({ commit }, payload) {
            commit('setComandosValidacaoLogData', payload)
        },
        setComandosValidacaoLogLoadingData({ commit }, payload) {
            commit('setComandosValidacaoLogLoadingData', payload)
        },
        setComandosValidacaoLogDataDetails({ commit }, payload) {
            commit('setComandosValidacaoLogDataDetails', payload)
        },
        setComandosValidacaoLogLoadingDataDetails({ commit }, payload) {
            commit('setComandosValidacaoLogLoadingDataDetails', payload)
        },
        setComandosValidacaoLogByReturns({ commit }, payload) {
            commit('setComandosValidacaoLogByReturns', payload)
        },
        setComandosValidacaoLogLoadingByReturns({ commit }, payload) {
            commit('setComandosValidacaoLogLoadingByReturns', payload)
        },
        setComandosValidacaoLogByWeeks({ commit }, payload) {
            commit('setComandosValidacaoLogByWeeks', payload)
        },
        setComandosValidacaoLogLoadingByWeeks({ commit }, payload) {
            commit('setComandosValidacaoLogLoadingByWeeks', payload)
        },
        setComandosValidacaoLogByVersions({ commit }, payload) {
            commit('setComandosValidacaoLogByVersions', payload)
        },
        setComandosValidacaoLogLoadingByVersions({ commit }, payload) {
            commit('setComandosValidacaoLogLoadingByVersions', payload)
        },
        setComandosValidacaoLogSnackBar({ commit }, payload) {
            commit('setComandosValidacaoLogSnackBar', payload)
        },
    }
}